import { render, staticRenderFns } from "./column-resize.vue?vue&type=template&id=1a5f3d68&scoped=true&"
import script from "./column-resize.vue?vue&type=script&lang=js&"
export * from "./column-resize.vue?vue&type=script&lang=js&"
import style0 from "./column-resize.vue?vue&type=style&index=0&id=1a5f3d68&prod&scoped=true&lang=scss&"
import style1 from "./column-resize.vue?vue&type=style&index=1&id=1a5f3d68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f3d68",
  null
  
)

export default component.exports